module.exports = __webpack_public_path__ + "static/media/products-dog.85cb3269.webp";